<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/ProjectDash.svg" class="h-20px w-20px rounded mr-2" />{{'Project' | localize}}
        </h5>
        <div  *ngIf="isLoaded && !isEmpty"  class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">
        <!--Empty state ui-->
        <div *ngIf="isLoaded && isEmpty">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-10">
                    <img src="../../../../assets/common/images/new-dashboard/team-dashboard-project.svg"
                         class="h-180px w-150px ml-8 rounded" />
                    <h6 class="text-muted mt-4 ml-10">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>

        <!--shimmer section code-->
        <div *ngIf="!isLoaded && isEmpty ">
            <div class="row px-3 mt-4" *ngFor="let x of [1, 2, 3, 4, 5]; trackBy: trackByIndex">
                <div class="col-md-3">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'30px'"></ngx-shimmer-loading>

                </div>

                <div class="col-md-3">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'30px'"></ngx-shimmer-loading>

                </div>

                <div class="col-md-3">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'30px'"></ngx-shimmer-loading>

                </div>

                <div class="col-md-3">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'30px'"></ngx-shimmer-loading>

                </div>
            </div>
        </div>

        <div class="overflow">
            <!--project-info section code-->
            <div *ngIf="isLoaded && !isEmpty">
                <div class="row px-4">
                    <div id="Team-Project-table" class="w-100">
                        <p-table class="detailsShow" [value]="this.projectInfo" [rows]="5" [resizableColumns]="true" responsiveLayout="scroll" [paginator]="true" [alwaysShowPaginator]="false">
                            <ng-template pTemplate="header">
                                <tr [ngClass]="'textcolor'">
                                    <th style="width: 42%;">{{'ProjectName' | localize}}</th>
                                    <th style="width: 22%;">{{'Employees' | localize}}</th>
                                    <th style="width: 18%;">{{'EndDate' | localize}}</th>
                                    <th style="width: 18%;">{{'Status' | localize}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-GetAllProjectDto>
                                <tr [ngClass]="'textcolor bg-hover-gray-100'" id="pointerClassOrg">
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <img alt="Pic" [src]="GetAllProjectDto.projectImage" class="img-fluid border border-light rounded w-35px h-35px" id="profimgsize" />
                                            </div>
                                            <div class="min-w-0">
                                                <span pTooltip="{{ GetAllProjectDto.name }}"
                                                      [tooltipDisabled]="GetAllProjectDto.name | tooltipDisabled:16"
                                                      tooltipPosition="bottom">
                                                    {{GetAllProjectDto.name| slice:0:15}}{{
                                            GetAllProjectDto.name.length > 15 ? '...' : ''
                                                    }}
                                                </span>
                                            </div>

                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <div class="d-flex align-items-center">
                                                        <div class="d-flex align-items-center">
                                                            <div class="d-flex justify-content-between align-items-center" (click)="redirectToViewPage(GetAllProjectDto.id, GetAllProjectDto.projectType)">
                                                                <profile-image-chain [interactive]="false" [userDetails]="GetAllProjectDto.teamProfileImage" [showConsolidatedViewLink]="false"></profile-image-chain>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            {{GetAllProjectDto.endDate | dateFormat}}
                                        </div>
                                    </td>
                                    <td>
                                        <span class="label label-outline-secondary label-pill rounded-pill h-28px w-50px label-inline border  bg-white justify-content-start"
                                              [ngClass]="{'w-60px': GetAllProjectDto.projectStatus == 2,'w-75px': GetAllProjectDto.projectStatus == 3}">

                                            <span class="label label-dot ml-0 mr-0"
                                                  [ngClass]="{'label-primary': GetAllProjectDto.projectStatus == 1,'label-info':GetAllProjectDto.projectStatus == 2,'label-success':GetAllProjectDto.projectStatus == 3,'label-danger':GetAllProjectDto.projectStatus == 4}"></span>
                                            <span *ngIf="GetAllProjectDto.projectStatus == 1" class="ml-1">{{'New' | localize}}</span>
                                            <span *ngIf="GetAllProjectDto.projectStatus == 2" class="ml-1">{{'Active' | localize}}</span>
                                            <span *ngIf="GetAllProjectDto.projectStatus == 3" class="ml-1">{{'Complete' | localize}}</span>
                                            <span *ngIf="GetAllProjectDto.projectStatus == 4" class="ml-1">{{'Closed' | localize}}</span>
                                        </span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
